export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            关于91电影
          </h2>
          <div className="mt-6 md:mt-8 text-sm md:text-base text-foreground-600 leading-relaxed space-y-4 max-w-3xl mx-auto">
            <p>
              91电影是一个专注国产电影推荐与资讯聚合的平台，致力于为广大影迷提供最新、最全的国产电影信息。从院线大片到独立佳作，从经典老片到最新上映，我们用心筛选每一部值得观看的国货电影。
            </p>
            <p>
              平台每日更新推荐内容，覆盖悬疑、动作、喜剧、文艺、科幻、历史等多种类型。无论是想追热门新片，还是寻找口碑好片，91电影都能帮你快速找到心仪的选择。
            </p>
            <p>
              我们的编辑团队由资深影迷和专业影评人组成，秉持客观、专业的态度，为每部电影提供真实可靠的推荐理由。让好电影被更多人看到，是91电影不变的初心。
            </p>
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {[
              { value: '2000+', label: '收录影片' },
              { value: '10万+', label: '月活用户' },
              { value: '98%', label: '好评率' },
              { value: '日更', label: '推荐频率' },
            ].map((item) => (
              <div key={item.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">
                  {item.value}
                </div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}